import React from 'react';
import './Myths.css';
import check from '../../Assests/assets/images/icons-8-checkmark-5-copy-4.png';
import cross from '../../Assests/assets/images/icons-8-x.png';
import {Row, Col} from 'antd';

const Myths = (props) => {
  return (
    <div class='myths-container'>
      <div class='myths-title-container'>
        <Row>
          <Col md={9} lg={7}/>
          <Col md={10} lg={10}>
            <span class="myths-title">
              Bursting some Myths about the Course
            </span>
          </Col>
          <Col md={7} lg={7}/>
        </Row>
      </div>
      <Row>
        <Col md={4} lg={4}/>
        <Col md={16} lg={16}>
          <Row className='myths-cards-container'>
            <Col sm={24} xl={12} className='myths-cards-col'>
              <div id="myth-card1" class='myths-card'>
                <span class='myths-card-title'>
                  Myth
                </span>
                <span class='myths-card-content'>
                  <div class='myths-card-bullet'>
                    <img src={cross}/>
                  </div>
                  <div>
                    Reading and analysing the financial statements
                    is the domain of a Commerce student ONLY.
                  </div>
                </span>
                <span class='myths-card-content'>
                  <div class='myths-card-bullet'>
                    <img src={cross}/>
                  </div>
                  <div>
                    Individuals from other streams do not require this particular skill to do performance and profitability analysis of a business.
                  </div>
                </span>
              </div>
            </Col>
            <Col sm={24} xl={12} className='myths-cards-col'>
              <div id="myth-card-last" class='myths-card'>
                <span class='myths-card-title'>
                  Truth
                </span>
                <span class='myths-card-content'>
                  <div class='myths-card-bullet'>
                    <img src={check}/>
                  </div>
                  <div>
                    Since reading and analysing Financial Statements requires an understanding of only the basic accounting principles, anyone from any field of study can master this skill.
                  </div>
                </span>
                <span class='myths-card-content'>
                  <div class='myths-card-bullet'>
                    <img src={check}/>
                  </div>
                  <div>
                    Individuals from non commerce/finance background, aspiring to pursue a masters degree or someone into accounting wanting to upgrade themselves can benefit the most from this course.
                  </div>
                </span>
              </div>
            </Col>
          </Row>
        </Col>
        <Col md={4} lg={4}/>
      </Row>
    </div>
  )
}
export default Myths;
